import React from "react";
import PTagFramer from "../framerMotion/PTagFramer";

interface DropdownItemProps {
  option: string;
  onSelect?: () => void;
  id?: string;
  index? : number;
  dropdownTestId ?:string
}
  const DropdownItem: React.FC<DropdownItemProps> = ({ option, onSelect, id, index, dropdownTestId,  }) => {
  return (
    <PTagFramer>
      <div
        className={`p-2.5 text-primary_text text-subTitle ${
          onSelect
            ? "cursor-pointer hover:bg-information_light hover:rounded-lg "
            : ""
        }`}
        onClick={onSelect}
        data-testid={`${dropdownTestId ? `${dropdownTestId}_${index}` : `${id}_${index}`}`}
      >
        {option}
      </div>
    </PTagFramer>
  );
};

export default DropdownItem;
